export const toTrim = (text: string) => {
    return text.replace(/\s+/g, ' ').trim()
}